import { render, staticRenderFns } from "./OrderEdit.vue?vue&type=template&id=554a34bb&scoped=true"
import script from "./OrderEdit.vue?vue&type=script&lang=js"
export * from "./OrderEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderEdit.vue?vue&type=style&index=0&id=554a34bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554a34bb",
  null
  
)

export default component.exports